var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRicerca(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 33,
    viewBox: "0 0 92 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ricerca",
    transform: "translate(-741 -670)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_53",
    "data-name": "Rettangolo 53",
    width: 92,
    height: 33,
    transform: "translate(741 670)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Orion_search-magnify",
    transform: "translate(759.297 658.298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "layer2",
    d: "M46.491,47.491a1,1,0,0,1-.707-.293l-8.3-8.3A1,1,0,1,1,38.9,37.484l8.3,8.3a1,1,0,0,1-.707,1.707Z",
    transform: "translate(-6.544 -6.544)",
    fill: "#8b8d8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "layer1",
    d: "M8.937-1A9.937,9.937,0,1,1-1,8.937,9.949,9.949,0,0,1,8.937-1Zm0,17.875A7.937,7.937,0,1,0,1,8.937,7.946,7.946,0,0,0,8.937,16.875Z",
    transform: "translate(15.702 15.702)",
    fill: "#8b8d8e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRicerca);
export default __webpack_public_path__ + "static/media/ricerca.32e5a4ce22d6241496c5135d2de18dd6.svg";
export { ForwardRef as ReactComponent };